<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑岗位' : '新增岗位'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :rules="rules" :model="selfData" label-width="100px">
        <el-form-item label="岗位名称:" prop="name">
          <el-input
            size="mini"
            :readonly="!selfData.is_able_change && !!selfData.id"
            v-model="selfData.name"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input size="mini" v-model="selfData.remark" autocomplete="off" />
        </el-form-item>
        <el-form-item label="排序:" prop="sort_num">
          <el-input
            type="number"
            size="mini"
            :controls="false"
            :min="0"
            :precision="0"
            v-model="selfData.sort_num"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="是否启用:">
          <el-switch
            :active-value="true"
            :inactive-value="false"
            v-model="selfData.is_enabled"
            @change="onEnabledChange"
          />
          <span v-if="selfData.user_count > 0" class="c-red m-l-10">
            岗位人数大于0，不能取消启用
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      rules: {
        name: [{ required: true, message: '请输入岗位名称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          // 合并默认值，保证新增/编辑时 sort_num、is_enabled 字段存在
          this.selfData = {
            sort_num: 0,
            is_enabled: true,
            user_count: 0,
            ...this.$util.deepCopy(val)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 是否启用-切换：岗位人数大于0时不能取消启用
    onEnabledChange(val) {
      if (!val && this.selfData.user_count > 0) {
        this.$message.warning('岗位人数大于0，不能取消启用')
        this.$nextTick(() => {
          this.selfData.is_enabled = true
        })
      }
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          let url = ''
          if (this.selfData.id) {
            url = '/admin/role/updateVue'
          } else {
            url = '/admin/role/saveVue'
          }
          this.$api({
            method: 'get',
            url: url,
            params: this.selfData
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.popupCancel()
              this.$emit('success')
              this.$message.success('保存成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
